module.exports = __webpack_public_path__ + "static/uni_sorenson_old-2f94e844715aed73643d8fea2b82132a.png";